import Vue from 'vue';
import lodash from 'lodash';
import moment from 'moment';
import Buefy from 'buefy';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuetify from 'vuetify'

import VueAuth from '@websanova/vue-auth';
import HTTPDriver from '@websanova/vue-auth/drivers/http/axios.1.x';
import RouterDriver from '@websanova/vue-auth/drivers/router/vue-router.2.x';
import 'buefy/dist/buefy.css';
import 'babel-polyfill';
import VueTimepicker from 'vue2-timepicker';

import VueGoogleChart from 'vue-charts';
import App from './App.vue';
import router from './router';
import store from './store';
import 'vuetify/dist/vuetify.min.css';

const DRFDriver = {
  request(req, token) {
    // eslint-disable-next-line
    this.options.http._setHeaders.call(
      this, req,
      { Authorization: `JWT ${token}` },
    );
  },
  response(res) {
    const token = (res.data && res.data.token) || null;
    return token;
  },
};

Vue.use(Vuetify)

Vue.use(VueAxios, axios);
Vue.use(VueTimepicker);

Vue.axios.defaults.baseURL = `${process.env.VUE_APP_BASE_API_URL || 'http://localhost:8001'}/api`;
if (process.env.VUE_APP_USE_ORIGIN) Vue.axios.defaults.baseURL = `${window.location.origin}/api`

Vue.router = router;
Vue.use(VueAuth, {
  auth: DRFDriver,
  http: HTTPDriver,
  router: RouterDriver,
  loginData: {
    url: 'users/login/',
    method: 'POST',
  },
  fetchData: {
    url: 'users/self',
    method: 'GET',
  },
  refreshData: {
    url: 'users/self',
    method: 'GET',
  },
  rolesVar: 'roles',
});


Vue.use(Buefy);


Object.defineProperty(Vue.prototype, '$lodash', { value: lodash });
Object.defineProperty(Vue.prototype, '$moment', { value: moment });

Vue.config.productionTip = false;

Vue.use(VueGoogleChart);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
